import $ from 'jquery'
import _ from 'lodash'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'
import env from '@/config/env'

import api from '@/api/api'

import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import TextareaField from '@/components/general/fields/textarea/textarea'
import SelectField from '@/components/general/fields/select/select'
import SearchField from '@/components/general/fields/search/search'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import FileField from '@/components/general/fields/file/file'
import DateField from '@/components/general/fields/date/date'
import SortField from '@/components/general/fields/sort/sort'

const Parse = require('parse')

export default {
  name: 'contracts-zips',
  data: function () {
    return {
      zips: [],
      menuOptions: [
        {
          iconClass: 'fa fa-pencil',
          name: this.$t('private.contracts.zips.menu_more_options.edit_contract'),
          action: 'edit'
        },
        {
          iconClass: 'fa fa-archive',
          name: this.$t('private.contracts.zips.menu_more_options.archive_contract'),
          action: 'archive'
        }
      ],
      filters: {
        limit: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.contracts.zips.filters.limit_options.10'),
          value: 50,
          name: this.$t('private.contracts.zips.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.zips.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        state: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.zips.filters.state'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.zips.filters.state_options.green'),
            value: 0
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.state_options.red'),
            value: 1
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.state_options.yellow'),
            value: 2
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.state_options.black'),
            value: 3
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.state_options.purple'),
            value: 4
          }],
          style: {
            width: '100px',
            marginTop: '0px'
          }
        },
        hidden: { // ESTO SE HACE POR QUE AL PARECER HAY UN BUG EN LOS FILTROS DENTRO DE LA TABLA Y ESTO LO SOLUCIONA
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.zips.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.zips.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.exported_options.no'),
            value: false
          }],
          style: {
            display: 'none'
          }
        },
        since: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.zips.filters.since'),
          error: false,
          active: false,
          style: {
            width: '110px',
            marginTop: '3px'
          }
        },
        until: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.zips.filters.until'),
          error: false,
          active: false,
          style: {
            width: '110px'
          }
        },
        skip: {
          value: 0
        }
      },
      getZipsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      displayFoo: false,
      totalZips: 0,
      exportZipPDFsWindow: {
        sessionId: null,
        display: false,
        downloadZipPDFsActive: false,
        fields: {
          month: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.zips.export_zip_pdfs_window.fields.month'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.list.export_zip_pdfs_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          contract: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: 'PDFs',
            error: false,
            active: false,
            options: [{
              value: 'Contract',
              fakeValue: 'Contracto'
            }, {
              value: 'SDA',
              fakeValue: 'SDA'
            }],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        },
        progress: {
          display: false,
          value: 0,
          valueMax: 0,
          download: 0
        }
      }
    }
  },
  methods: {
    filterSubmit: _.debounce(function () {
      let vm = this

      vm.getZips()
    }, 1000),
    rowClicked (element, value) {
      element.rowSelected = value

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true
    },
    actionSort (event, col) {
      let vm = this

      vm.filters.ascending.value = ''
      vm.filters.descending.value = ''

      if (event.sort_default) vm.filters.descending.value = 'appCreationDate'

      if (event.sort_asc) vm.filters.ascending.value = col

      if (event.sort_desc) vm.filters.descending.value = col

      vm.getZips()
    },
    getZips () {
      let vm = this

      vm.getZipsActive = true
      vm.totalZips = 0
      vm.zips = []

      let dataToSend = {
        limit: (vm.filters.limit.value + 1),
        skip: vm.filters.skip.value
        // state  : vm.filters.state.value,
        // since  : vm.filters.since.value,
        // until  : vm.filters.until.value
      }

      api
        .contractsZips
        .getZips(dataToSend)
        .then((response) => {
          vm.getZipsActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.totalZips = response.data.count
          vm.zips = response.data.results

          if (vm.zips.length > 0 && !vm.haveData) {
            vm.haveData = true
          }

          if (vm.zips.length > vm.filters.limit.value) {
            vm.nextPage = true

            vm.zips.pop()
          } else {
            vm.nextPage = false
          }
        })
    },
    goToBackPage () {
      let vm = this

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

        vm.getZips()
      }
    },
    goToNextPage () {
      let vm = this

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

        vm.getZips()
      }
    },
    exportZipPDFs () {
      let vm = this

      if (vm.exportZipPDFsWindow.downloadZipPDFsActive) {
        let message = {
          message: [vm.$t('private.contracts.zips.please_wait')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      let year = vm.exportZipPDFsWindow.fields.year.value
      let month = vm.exportZipPDFsWindow.fields.month.value

      let since = moment().tz(env.timeZone).year(year).month(month - 1).startOf('month')
      let until = moment().tz(env.timeZone).year(year).month(month - 1).endOf('month')

      vm.exportZipPDFsWindow.sessionId = Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, 20)
      vm.exportZipPDFsWindow.fields.month.disabled = true
      vm.exportZipPDFsWindow.fields.year.disabled = true
      vm.exportZipPDFsWindow.downloadZipPDFsActive = true

      console.log('since', since.toDate())
      console.log('until', until.toDate())

      let dataToSend = {
        since: since.format(),
        until: until.format(),
        timeZone: env.timeZone,
        sessionId: vm.exportZipPDFsWindow.sessionId,
        contract: vm.exportZipPDFsWindow.fields.contract.value,
        month: _.capitalize(since.format('MMMM')),
        year
      }

      api
        .contractsZips
        .createZip(dataToSend)
        .then((response) => {
          vm.exportZipPDFsWindow.downloadZipPDFsActive = false
          vm.exportZipPDFsWindow.fields.month.disabled = false
          vm.exportZipPDFsWindow.fields.year.disabled = false

          if (response.status == 202) {
            let message = {
              message: [vm.$t('errors.custom.011')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            if (response.data.error.code == 101) {
              let message = {
                message: [vm.$t('errors.parse.101')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (response.data.error.code == 325) {
              let message = {
                message: [vm.$t('errors.custom.016')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            let message = {
              message: [vm.$t('errors.custom.011')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let message = {
            message: [vm.$t('private.contracts.zips.create_success')],
            type: 'success'
          }

          vm.$root.$emit('showMessage', message)

          vm.exportZipPDFsWindow.display = false
          vm.resetForm()
          setTimeout(vm.getZips, 3000)
        })
    },
    generateMoths () {
      let vm = this

      let lang = navigator.language || navigator.userLanguage

      moment.locale(lang)

      let year = vm.exportZipPDFsWindow.fields.year.value

      let dateNow = moment()
      let dateSelectedYear = moment().year(year)
      let monthNow = 12

      if (dateNow.year() === dateSelectedYear.year()) monthNow = dateSelectedYear.month() + 1

      vm.exportZipPDFsWindow.fields.month.options = []
      vm.exportZipPDFsWindow.fields.month.disabled = true

      for (let i = 0; i < monthNow; ++i) {
        vm.exportZipPDFsWindow.fields.month.options.push({
          fakeValue: _.capitalize(moment().month(i).format('MMMM')),
          value: i + 1
        })
      }

      vm.exportZipPDFsWindow.fields.month.value = ''
      vm.exportZipPDFsWindow.fields.month.fakeValue = ''
      vm.exportZipPDFsWindow.fields.month.disabled = false
    },
    resetForm () {
      let vm = this

      vm.exportZipPDFsWindow.fields.year.value = ''
      vm.exportZipPDFsWindow.fields.month.value = ''
      vm.exportZipPDFsWindow.fields.month.disabled = false
      vm.exportZipPDFsWindow.fields.year.disabled = false
      vm.exportZipPDFsWindow.downloadZipPDFsActive = false
    },
    generateSlug (name, toUpperCase, replaceSpaceBy) {
      let _name = toUpperCase ? _.deburr(name).toUpperCase() : _.deburr(name).toLowerCase()

      return _name.replace(/\s+/g, replaceSpaceBy || '').toString()
    },
    getAgreement (contract, key) {
      let agreements = []

      if (contract[`${key}1`]) agreements.push(contract[`${key}1`])
      if (contract[`${key}2`]) agreements.push(contract[`${key}2`])
      if (contract[`${key}3`]) agreements.push(contract[`${key}3`])

      return agreements.join(' - ')
    },
    parseDate (date, format) {
      date = _.has(date, 'iso') ? date.iso : date

      return moment(new Date(date)).format(format)
    },
    validateExpire (date) {
      date = _.has(date, 'iso') ? date.iso : date

      return moment().isAfter(moment(date))
    },
    deleteZip (element) {
      let vm = this

      let questionModal = {
        title: this.$t('private.contracts.zips.question_modal.title'),
        question: this.$t('private.contracts.zips.question_modal.question')
      }

      vm.$root.$emit('question-modal', [questionModal, (response) => {
        if (response) {
          api
            .contractsZips
            .deleteZip(element.objectId)
            .then((response) => {
              vm.getZips()

              if (response.status != 200) {
                let message = {
                  message: [vm.$t('errors.custom.001')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              if (!response.data.success) {
                if (response.data.error.code == 101) {
                  let message = {
                    message: [vm.$t('errors.parse.101')],
                    type: 'error'
                  }

                  vm.$root.$emit('showMessage', message)
                }

                if (response.data.error.code == 404) {
                  let message = {
                    message: [vm.$t('errors.custom.404')],
                    type: 'error'
                  }

                  vm.$root.$emit('showMessage', message)
                }

                return
              }

              let message = {
                message: [vm.$t('private.contracts.zips.delete_success')],
                type: 'success'
              }

              vm.$root.$emit('showMessage', message)
            })
        }
      }])
    }
  },
  components: {
    MenuMoreOptions,
    TextField,
    TextareaField,
    SelectField,
    SearchField,
    CheckboxField,
    FileField,
    DateField,
    SortField
  },
  created () {
    let vm = this

    vm.getZips()

    for (let i = 2017; i <= moment().year(); i++) {
      vm.exportZipPDFsWindow.fields.year.options.push({
        fakeValue: i,
        value: i
      })
    }
  },
  mounted () {
    let vm = this

    let queryProgress = new Parse.Query('FilesZips')

    let subscriptionProgress = queryProgress.subscribe()

    subscriptionProgress.on('open', () => {

    })

    subscriptionProgress.on('create', (event) => {
      const isPartitioned = event.get('isPartitioned')
      if (isPartitioned) {
        setTimeout(vm.getZips, 3000)
      }
    })

    subscriptionProgress.on('update', (event) => {
      // let sessionId   = event.get('sessionId');

      // if(vm.exportZipPDFsWindow.sessionId !== sessionId) return;

      let state = event.get('state')
      let count = event.get('count')
      let valueMax = event.get('valueMax')

      console.log('event', event.id)
      console.log('count', count)
      console.log('valueMax', valueMax)

      vm.exportZipPDFsWindow.progress.display = true
      vm.exportZipPDFsWindow.progress.value = count
      vm.exportZipPDFsWindow.progress.valueMax = valueMax

      for (let i = 0; i < vm.zips.length; i++) {
        if (vm.zips[i].objectId == event.id) {
          vm.zips[i].count = count
          vm.zips[i].state = state
        }
      }

      let porcentaje = Math.floor((count / valueMax * 100))

      if (count > 0) {
        $(`#${event.id}`).text(porcentaje + '%')
        $(`#${event.id}`).attr('aria-valuenow', porcentaje)
        $(`#${event.id}`).css('width', porcentaje + '%')
      }

      if (state === 'downloadable') {
        // subscriptionProgress.unsubscribe();
        setTimeout(vm.getZips, 3000)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/private/contracts/zips/script.js